module controllers {
    export module integration {

        interface ISmartInvoiceCtrlScope extends ng.IScope {
        }

        interface ISmartInvoiceParams extends ng.ui.IStateParamsService  {
        }

        export class smartInvoiceListCtrl {

            static $inject = ["$scope",
                "$rootScope",
                "generalService",
                "$q",
                "bsLoadingOverlayService",
                "entityService",
                "$timeout",
                "$uibModal",
                "$state",
                "$stateParams",
                "$transitions",
                "smartInvoiceService",
                'countryService',
            ];

            IsLoading: boolean = false;
            gridApi: uiGrid.IGridApi;

            searchAccordian: boolean = false;
            myHook: any;

            smartInvoiceSearch: interfaces.integration.ISmartInvoiceQueueSearch = {
            };

            paginationOptions = {
                pageNumber: 1,
                pageSize: 25
            };

            ctrlName: string = "smartinvoice list";
            sortName: string;
            sortDirection: string;

            filterNames: string[] = ["ConsignmentNumber", "CommercialInvoiceNumber", "ReferenceNumber", "RegistrationNumber", "AssessmentDate", "Sequence", "Operation", "FromBranch", "ToBranch", "Pending", "DateQueued", "IsProcessed", "IsSuccessful", "ResponseJSON", "IntegrationLogId", "UpdateStampDate","Reset"];

            filterList: interfaces.applicationcore.IKeyValue[] = [];            

            selectedCountry :interfaces.applicationcore.IDropdownModel;
            
            constructor(private $scope: ISmartInvoiceCtrlScope,
                private $rootScope: interfaces.applicationcore.IRootScope,
                public generalService: interfaces.applicationcore.IGeneralService,
                private $q: ng.IQService, private bsLoadingOverlayService,
                private entityService: interfaces.applicationcore.IEntityService,
                private $timeout: ng.ITimeoutService,
                private $uibModal: ng.ui.bootstrap.IModalService,
                private $state: ng.ui.IStateService,
                private $stateParams: ISmartInvoiceParams,
                private $transitions: ng.ui.core.ITransition,
                private smartInvoiceService: interfaces.integration.ISmartInvoiceService,
                public countryService: interfaces.applicationcore.ICountryService,
            ) {

                console.log("In smartInvoiceListCtrl");
                
                this.myHook = $transitions.onSuccess({
                    to: 'auth.SmartInvoiceLog',
                    from: 'auth.SmartInvoiceLog.**'
                }, () => {
                    this.loadSmartInvoices();

                });

                $scope.$on('$destroy', () => {
                    $transitions.onStart({}, this.myHook)
                });

                this.loadSmartInvoices();
            }

            
            loadSmartInvoices(){
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'smartInvoiceList'
                },
                    () => {
                        var searchObject: interfaces.applicationcore.ISearchObject = {
                            filters: [],
                            sorts: []
                        }

                        angular.forEach(this.smartInvoiceSearch, (n, key) => {
                            if (n["Id"]) {
                                searchObject.filters.push({ Name: key, Value: n.Id });
                            } else {
                                searchObject.filters.push({ Name: key, Value: n });
                            }
                        });



                        if (this.gridApi) {
                            var grid = this.gridApi.grid;
                            angular.forEach(grid.columns, (n: uiGrid.IGridColumn) => {
                                if (n.filters[0].term) {
                                    searchObject.filters.push({ Name: n.name, Value: n.filters[0].term });
                                }

                                if (n.sort.direction) {
                                    searchObject.sorts.push({
                                        Name: n.name,
                                        SortDirection: n.sort.direction === "asc" ? 0 : 1,
                                        SortOrder: n.sort.priority
                                    });
                                }
                            });
                        }

                        var params = {
                            connectSearch: searchObject,
                            numberRecords: this.paginationOptions.pageSize,
                            pageNumber: this.paginationOptions.pageNumber,
                        }

                        return this.smartInvoiceService.getSmartInvoiceQueue().query(params, (result: Array<interfaces.integration.SmartInvoiceQueue>) => {
                            this.gvwSmartInvoices.data = result;
                            if (result[0]) {
                                this.gvwSmartInvoices.totalItems = result[0].NumRecs;
                            } else {
                                this.gvwSmartInvoices.totalItems = 0;
                            }                            
                            this.$timeout(() => {
                                if (this.gridApi) {
                                    this.getFilters();
                                    this.setFilters();
                                }
                            });
                        }, (errorResponse) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        }).$promise;
                    });
            }
// ["consignmentNumber", "commercialInvoiceNumber", "mrnNumber", "referenceNumber", "registrationNumber", "assessmentDate", "sequence", "operation", "fromBranch", "toBranch", "pending", "dateQueued", "isProcessed", "isSuccessful", "responseJSON", "integrationLogId", "updateStampDate"];
            public gvwSmartInvoices: uiGrid.IGridOptions | any = {
                data: [],
                enableSorting: true,
                enableFiltering: true,
                useExternalFiltering: true,
                enableCellEdit: false,
                useExternalSorting: true,
                multiSelect: false,
                enableColumnResizing: true,
                enableRowSelection: false,
                enableFullRowSelection: false,
                enableRowHeaderSelection: false,
                enableHorizontalScrollbar: 2,
                enablePinning: false,
                rowEditWaitInterval: -1,
                paginationPageSizes: [25, 50, 75, 100],
                paginationPageSize: 25,
                enableVerticalScrollbar: 1,
                useExternalPagination: true,
                enableGridMenu: false,
                exporterMenuCsv: false,
                exporterMenuPdf: false,
                exporterMenuExcel: false,
                gridMenuShowHideColumns: false,
                exporterFieldCallback: (grid, row, col, value) => {
                    return this.generalService.handleValue(value);
                },
                exporterSuppressColumns: ['EDIT', 'NUMRECS'],
                onRegisterApi: (gridApi) => { this.registerGridApi(gridApi) },
                rowTemplate: `<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader, 'SLA-amber': row.entity.UpdatedWithinLastDay}" ui-grid-cell></div>`,
                columnDefs: [
                {
                    name: "DeclarationCountry",
                    displayName: "Declaration Country",
                    field: "DeclarationCountry",
                    width: 120,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                        cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                },                    
                {
                    name: "ConsignmentNumber",
                    displayName: "Consignment Number",
                    field: "ConsignmentNumber",
                    width: 120,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                        cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                }, 
                {
                    name: "CommercialInvoiceNumber",
                    displayName: "Invoice Number",
                    field: "CommercialInvoiceNumber",
                    width: 140,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                        cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                },     
 {
                    name: "ReferenceNumber",
                    displayName: "Reference Number",
                    field: "ReferenceNumber",
                    width: 140,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                        cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                }, 
 {
                    name: "RegistrationNumber",
                    displayName: "Registration Number",
                    field: "RegistrationNumber",
                    width: 140,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                        cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                },  
                {
                    name: "AssessmentDate",
                    displayName: "Assessment Date",
                    field: "AssessmentDate",
                    cellFilter: 'momentDateFilter:"YYYY/MM/DD"',
                    width: 100,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <gts-date format="yyyy/MM/dd" ng-model="colFilter.term" name="estimateDateOfLoading"></gts-date>
                            </div>`,
                },                                                       
                {
                    name: "Sequence",
                    displayName: "Sequence",
                    field: "Sequence",
                    width: 70,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                        cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                },                                        
                {
                    name: "Operation",
                    displayName: "Operation",
                    field: "Operation",
                    width: 120,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                        cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                },       
                {
                    name: "FromBranch",
                    displayName: "From Branch",
                    field: "FromBranch",
                    width: 50,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                        cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                },
                {
                    name: "ToBranch",
                    displayName: "To Branch",
                    field: "ToBranch",
                    width: 50,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                        cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                },  
                {
                    name: "Pending",
                    displayName: "Pending",
                    field: "Pending",
                    width: 100,
                        cellTemplate: '<input type="checkbox" ng-disabled="true" ng-model="MODEL_COL_FIELD" />',
                        filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="checkbox" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`
                },                    
                {
                    name: "DateQueued",
                    displayName: "Date Queued",
                    field: "DateQueued",
                    width: 125,
                    cellFilter: 'momentDateFilter:"YYYY/MM/DD HH:mm:SS"',
                    filterHeaderTemplate: `
                    <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                        <gts-date format="yyyy/MM/dd" ng-model="colFilter.term" name="SLA"></gts-date>
                    </div>`,
                },         
            {
                    name: "IsProcessed",
                    displayName: "Processed",
                    field: "IsProcessed",
                    width: 100,
                        cellTemplate: '<input type="checkbox" ng-disabled="true" ng-model="MODEL_COL_FIELD" />',
                        filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="checkbox" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`
                },
                {
                    name: "IsSuccessful",
                    displayName: "Successful",
                    field: "IsSuccessful",
                    width: 100,
                        cellTemplate: '<input type="checkbox" ng-disabled="true" ng-model="MODEL_COL_FIELD" />',
                        filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="checkbox" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`
                },                                                  
                {
                    name: "ResponseJSON",
                    displayName: "Response",
                    field: "ResponseJSON",
                    width: 150,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                      cellTemplate: `<div class="ui-grid-cell-contents" uib-popover="{{MODEL_COL_FIELD}}" popover-enable="{{MODEL_COL_FIELD.length >= 20}}" popover-trigger="'mouseenter'" popover-append-to-body="true">{{MODEL_COL_FIELD}}</div>`,
                },         
                {
                    name: "UpdateStampDate",
                    displayName: "Updated",
                    field: "UpdateStampDate",
                    width: 125,
                    cellFilter: 'momentDateFilter:"YYYY/MM/DD HH:mm:SS"',
                    filterHeaderTemplate: `
                    <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                        <gts-date format="yyyy/MM/dd" ng-model="colFilter.term" name="SLA"></gts-date>
                    </div>`,
                },
               {
                    name: "Reset",
                    displayName: "",
                    field: "",
                    width: 40,
                    enableFiltering: false,
                    enableColumnResizing: true,
                    cellTemplate: `
                    
                    <div class="GridButton" ng-if="row.entity.Pending === false && row.entity.IsSuccessful === false">                   
                        <center>
                              <button  title ="Reprocess" type="button" class="btn btn-info btn-sm" ng-click="grid.appScope.smartInvoiceListCtrl.resetSmartInvoiceQueues_Click(row.entity.Id)">
                                <span class="fa fa-refresh"></span>
                            </button>
                        </center>
                    </div>`,                  
                    enableSorting: false,
                    headerTooltip: "Classification Opinion"
                }                
                ]                
            }

         resetSmartInvoiceQueues_Click(id: number){
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'smartInvoiceList'
                }, () => {
                    return this.resetSmartInvoiceQueue(id).then((result) => {
                        this.generalService.displayMessageHandler(result);
                        if (!result.HasErrorMessage) {
                             this.loadSmartInvoices();
                        }
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    });
                });
            }         
        

              resetSmartInvoiceQueue(id: number) {
                return this.smartInvoiceService.resetSmartInvoiceQueue().save({
                    smartInvoiceQueueId: id
                }).$promise;
            };

            public registerGridApi(gridApi: uiGrid.IGridApi) {
                this.gridApi = gridApi;

                this.gridApi.core.on.filterChanged(this.$scope, () => { this.smartInvoiceListFilterChange(gridApi) });
                this.gridApi.core.on.sortChanged(this.$scope, (grid, sortColumns) => {
                    this.smartInvoiceListSortChange(gridApi);
                    if (sortColumns[0]) {
                        this.sortName = sortColumns[0].name;
                        this.sortDirection = sortColumns[0].sort.direction;
                    }
                    else {
                        this.sortName = "";
                        this.sortDirection = "";
                    }
                });


                this.gridApi.pagination.on.paginationChanged(this.$scope, (newPage, pageSize) => { this.ListPageChange(newPage, pageSize) });

                this.gridApi.cellNav.on.navigate(this.$scope, (newCol) => {
                    this.$timeout(() => {
                        this.gridApi.selection.selectRow(newCol.row.entity);
                    });
                });
            }
            
            smartInvoiceListSortChange(gridApi) {
                this.DoSearch();
            }
            
            smartInvoiceListFilterChange(gridApi: uiGrid.IGridApi) {
                this.DoSearch();
            }

            ListPageChange(newPage, pageSize) {

                this.paginationOptions.pageNumber = newPage;
                this.paginationOptions.pageSize = pageSize;

                this.DoSearch();
            }

            DoSearch() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'smartInvoiceList'
                },
                    () => {
                        var searchObject: interfaces.applicationcore.ISearchObject = {
                            filters: [],
                            sorts: []
                        }

                        angular.forEach(this.smartInvoiceSearch, (n, key) => {
                            if (n) {
                                if (n["Id"]) {
                                    searchObject.filters.push({ Name: key, Value: n.Id });
                                } else {
                                    if (n instanceof moment) {
                                        searchObject.filters.push({ Name: key, Value: n });
                                    } else {
                                        searchObject.filters.push({ Name: key, Value: n });
                                    }
                                }
                            }
                        });

                       // searchObject.filters.push({ Name: "Country", Value: this.selectedCountry.Id });

                        if (this.gridApi) {
                            var grid = this.gridApi.grid;
                            angular.forEach(grid.columns, (n: uiGrid.IGridColumn) => {
                                if (n.filters[0].term) {
                                    searchObject.filters.push({ Name: n.name, Value: n.filters[0].term });
                                }

                                if (n.sort.direction) {
                                    searchObject.sorts.push({
                                        Name: n.name,
                                        SortDirection: n.sort.direction === "asc" ? 0 : 1,
                                        SortOrder: n.sort.priority
                                    });
                                }
                            });
                        }

                        var params = {
                            connectSearch: searchObject,
                            numberRecords: this.paginationOptions.pageSize,
                            pageNumber: this.paginationOptions.pageNumber,
                        }

                        return this.smartInvoiceService.getSmartInvoiceQueue().query(params, (result: Array<interfaces.integration.SmartInvoiceQueue>) => {
                            var currentDirtyRows: Array<interfaces.integration.SmartInvoiceQueue> = [];

                            /*_.forEach(this.allDirtyRows, function (value) {
                                var row: interfaces.master.IVesselDisplay = _.find(result, _.matchesProperty('Id', value.Id));

                                if (row) {
                                    var i: number = _.indexOf(result, row);
                                    result[i] = value;
                                    currentDirtyRows.push(result[i]);
                                }
                            });*/

                            this.gvwSmartInvoices.data = result;

                            if (currentDirtyRows.length > 0) {
                                this.$timeout(() => {
                                    _.forEach(currentDirtyRows, (value) => {
                                        this.gridApi.rowEdit.setRowsDirty(currentDirtyRows);
                                    });
                                });
                            }

                            if (result[0]) {
                                this.gvwSmartInvoices.totalItems = result[0].NumRecs;
                            } else {
                                this.gvwSmartInvoices.totalItems = 0;
                            }

                                this.$timeout(() => {
                                if (this.gridApi) {
                                    //this.getFilters();
                                    //this.setFilters();
                                }
                            });
                            
                        }, (errorResponse) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        }).$promise;
                    });
            }

            search_click() {
                this.searchAccordian = false;
                this.DoSearch();
            }

            
            getFilters() {
                _.forEach(this.filterNames, (name: string) => {
                   
                    if (this.gridApi.grid.getColumn(name).filters[0].term || this.gridApi.grid.getColumn(name).filters[0].term == "") {
                        var keyValue: interfaces.applicationcore.IKeyValue = _.find(this.filterList, _.matchesProperty('key', name));

                        if (keyValue) {
                            var index = _.findIndex(this.filterList, (o) => { return o.key === name });

                            this.filterList[index] = <interfaces.applicationcore.IKeyValue>{
                                key: name,
                                value: this.gridApi.grid.getColumn(name).filters[0].term
                            };
                        }
                        else {
                            this.filterList.push(<interfaces.applicationcore.IKeyValue>{
                                key: name,
                                value: this.gridApi.grid.getColumn(name).filters[0].term
                            });
                        }
                    }
                });
            }

            setFilters() {
                if (this.filterList) {
                    _.forEach(this.filterList, (keyValue: interfaces.applicationcore.IKeyValue) => {
                        this.gridApi.grid.getColumn(keyValue.key).filters[0].term = keyValue.value;
                    });
                }

                if (this.sortName && this.sortDirection) {
                    this.gridApi.grid.getColumn(this.sortName).sort.direction = this.sortDirection;
                }
            }

            editSmartInvoice(vshId: number){
                this.$state.go("auth.SmartInvoice.Update", { vshId: vshId });
            }

            createNewSmartInvoice(){
                this.$state.go("auth.SmartInvoice.Update", { vshId: 0 });
            }


    
        }
         angular.module("app").controller("smartInvoiceListCtrl", controllers.integration.smartInvoiceListCtrl);    
    }
}